"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowParser = void 0;

var column_1 = require("./column");

var Token_1 = require("./Token");

var EMPTY_STRING = '';

var RowParser = /*#__PURE__*/function () {
  function RowParser(parserOptions) {
    _classCallCheck(this, RowParser);

    this.parserOptions = parserOptions;
    this.columnParser = new column_1.ColumnParser(parserOptions);
  }

  _createClass(RowParser, [{
    key: "parse",
    value: function parse(scanner) {
      var parserOptions = this.parserOptions;
      var hasMoreData = scanner.hasMoreData;
      var currentScanner = scanner;
      var columns = [];
      var currentToken = this.getStartToken(currentScanner, columns);

      while (currentToken) {
        if (Token_1.Token.isTokenRowDelimiter(currentToken)) {
          currentScanner.advancePastToken(currentToken); // if ends with CR and there is more data, keep unparsed due to possible
          // coming LF in CRLF

          if (!currentScanner.hasMoreCharacters && Token_1.Token.isTokenCarriageReturn(currentToken, parserOptions) && hasMoreData) {
            return null;
          }

          currentScanner.truncateToCursor();
          return columns;
        }

        if (!this.shouldSkipColumnParse(currentScanner, currentToken, columns)) {
          var item = this.columnParser.parse(currentScanner);

          if (item === null) {
            return null;
          }

          columns.push(item);
        }

        currentToken = currentScanner.nextNonSpaceToken;
      }

      if (!hasMoreData) {
        currentScanner.truncateToCursor();
        return columns;
      }

      return null;
    }
  }, {
    key: "getStartToken",
    value: function getStartToken(scanner, columns) {
      var currentToken = scanner.nextNonSpaceToken;

      if (currentToken !== null && Token_1.Token.isTokenDelimiter(currentToken, this.parserOptions)) {
        columns.push('');
        return scanner.nextNonSpaceToken;
      }

      return currentToken;
    }
  }, {
    key: "shouldSkipColumnParse",
    value: function shouldSkipColumnParse(scanner, currentToken, columns) {
      var parserOptions = this.parserOptions;

      if (Token_1.Token.isTokenDelimiter(currentToken, parserOptions)) {
        scanner.advancePastToken(currentToken); // if the delimiter is at the end of a line

        var nextToken = scanner.nextCharacterToken;

        if (!scanner.hasMoreCharacters || nextToken !== null && Token_1.Token.isTokenRowDelimiter(nextToken)) {
          columns.push('');
          return true;
        }

        if (nextToken !== null && Token_1.Token.isTokenDelimiter(nextToken, parserOptions)) {
          columns.push('');
          return true;
        }
      }

      return false;
    }
  }], [{
    key: "isEmptyRow",
    value: function isEmptyRow(row) {
      return row.join(EMPTY_STRING).replace(/\s+/g, EMPTY_STRING) === EMPTY_STRING;
    }
  }]);

  return RowParser;
}();

exports.RowParser = RowParser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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